import { ApolloProvider } from '@apollo/client';
import { ComponentType } from 'react';

import { apolloClient } from './client';

export const wrapWithApolloProvider = (
  Component: ComponentType<Record<string, unknown>>,
): ComponentType<Record<string, unknown>> => {
  const WrappedComponent = (props: Record<string, unknown>): React.ReactElement => (
    <ApolloProvider client={apolloClient}>
      <Component {...props} />
    </ApolloProvider>
  );
  // see react/display-name eslint rule
  WrappedComponent.displayName = `ApolloProviderWrapped${Component.displayName ?? Component.name}`;
  return WrappedComponent;
};
